(function() {
  if (window.__nbnProductCardQuickAddGuard) return;
  window.__nbnProductCardQuickAddGuard = true;

  function sectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector)?.innerHTML;
  }

  function sectionsToRender() {
    return [
      { id: "Cart", section: "main-cart", selector: ".thb-cart-form" },
      { id: "Cart-Drawer", section: "cart-drawer", selector: ".cart-drawer" },
      { id: "cart-drawer-toggle", section: "cart-bubble", selector: ".thb-secondary-area--item-count" },
      { id: "cart-drawer-toggle", section: "cart-bubble", selector: ".thb-secondary-area--item-amount" }
    ];
  }

  function cartAddUrl() {
    return (window.theme && theme.routes && theme.routes.cart_add_url) || "/cart/add";
  }

  function setLoading(button, isLoading) {
    button.classList.toggle("loading", isLoading);
    if (isLoading) {
      button.disabled = true;
      button.setAttribute("aria-disabled", "true");
    } else {
      button.disabled = false;
      button.removeAttribute("aria-disabled");
    }
  }

  function renderCartSections(parsedState) {
    if (!parsedState || !parsedState.sections) return;
    sectionsToRender().forEach(function(section) {
      var root = document.getElementById(section.id);
      if (!root || !parsedState.sections[section.section]) return;
      var target = root.querySelector(section.selector) || root;
      var replacement = sectionInnerHTML(parsedState.sections[section.section], section.selector);
      if (replacement !== undefined) target.innerHTML = replacement;
    });

    var drawer = document.getElementById("Cart-Drawer");
    if (drawer) {
      if (typeof drawer.open === "function") drawer.open();
      if (typeof drawer.removeProductEvent === "function") drawer.removeProductEvent();
    }

    if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.show === "function") {
      window.Rebuy.SmartCart.show();
    } else if (!drawer) {
      document.getElementById("cart-drawer-toggle")?.click();
    }
  }

  function closeQuickViewDrawer(sourceElement) {
    var drawer = sourceElement?.closest('dialog, #Product-Modal, product-modal, #Product-Drawer, .side-panel, .drawer, .quick-view-modal, .product-popup-modal, .modal') || document.getElementById("Product-Modal") || document.getElementById("Product-Drawer");
    if (!drawer) return;

    var closeButton = drawer.querySelector('.product-modal__toggle, [data-close], [data-drawer-close], .side-panel-close, .drawer__close, .thb-close, button[aria-label*="close" i], button[aria-label*="Close" i]');
    if (closeButton) closeButton.click();

    if (typeof drawer.close === "function" && drawer.open) drawer.close();
    drawer.removeAttribute("open");
    drawer.classList.remove("active");
    drawer.setAttribute("inert", "");
    document.body.classList.remove("open-cc", "overflow-hidden");
    document.querySelector(".click-capture")?.classList.remove("active");
  }

  function productModal() {
    return document.getElementById("Product-Modal");
  }

  function quickViewScrollTarget(modal) {
    return modal || null;
  }

  var quickViewPageScrollY = 0;

  function unlockQuickViewBody() {
    var restoreScrollY = quickViewPageScrollY;
    document.body.classList.remove("open-cc", "overflow-hidden", "nbn-quick-view-open");
    document.body.style.removeProperty("overflow");
    document.body.style.removeProperty("position");
    document.body.style.removeProperty("top");
    document.body.style.removeProperty("left");
    document.body.style.removeProperty("right");
    document.body.style.removeProperty("width");
    document.documentElement.style.removeProperty("overflow");
    document.querySelector(".click-capture")?.classList.remove("active");
    if (restoreScrollY && Math.abs(window.scrollY - restoreScrollY) > 2) {
      window.scrollTo(0, restoreScrollY);
    }
    quickViewPageScrollY = 0;
  }

  function setQuickViewGalleryDraggable(modal, draggable) {
    if (!modal || window.matchMedia("(min-width: 768px)").matches) return;
    modal.querySelectorAll("product-slider").forEach(function(slider) {
      if (typeof slider.setDraggable === "function") {
        try {
          slider.setDraggable(draggable);
        } catch (error) {
          console.warn("NBN quick view gallery draggable fallback used", error);
        }
      }
    });
  }

  function resetQuickViewState(options) {
    var modal = productModal();
    if (!modal) return;
    if (quickViewMomentumFrame) {
      window.cancelAnimationFrame(quickViewMomentumFrame);
      quickViewMomentumFrame = 0;
    }
    setQuickViewGalleryDraggable(modal, true);
    modal.removeAttribute("open");
    modal.classList.remove("active", "loading", "nbn-quick-view-stable");
    modal.removeAttribute("aria-busy");
    modal.removeAttribute("inert");
    modal.scrollTop = 0;
    var scrollTarget = quickViewScrollTarget(modal);
    if (scrollTarget && scrollTarget !== modal) scrollTarget.scrollTop = 0;
    var content = modal.querySelector("#Product-Modal-Content");
    if (content) {
      content.scrollTop = 0;
      if (!options || options.clearContent !== false) content.innerHTML = "";
    }
    quickViewTouch = null;
    unlockQuickViewBody();
  }

  function closeProductModal(modal) {
    if (!modal) return;
    try {
      if (typeof modal.hide === "function") modal.hide();
    } catch (error) {
      console.warn("NBN quick view modal hide fallback used", error);
    }
    resetQuickViewState();
  }

  function setQuickViewViewportHeight() {
    var viewportHeight = window.visualViewport && window.visualViewport.height ? window.visualViewport.height : window.innerHeight;
    if (viewportHeight) document.documentElement.style.setProperty("--nbn-quick-view-height", viewportHeight + "px");
  }

  function stabiliseProductModal() {
    var modal = productModal();
    if (!modal || !modal.hasAttribute("open")) return;
    setQuickViewViewportHeight();
    if (!quickViewPageScrollY) quickViewPageScrollY = window.scrollY || window.pageYOffset || 0;
    document.body.classList.add("overflow-hidden", "nbn-quick-view-open");
    document.body.style.position = "fixed";
    document.body.style.top = "-" + quickViewPageScrollY + "px";
    document.body.style.left = "0";
    document.body.style.right = "0";
    document.body.style.width = "100%";
    document.body.style.overflow = "hidden";
    document.documentElement.style.overflow = "hidden";
    modal.classList.add("nbn-quick-view-stable");
    setQuickViewGalleryDraggable(modal, false);
    window.setTimeout(function() { setQuickViewGalleryDraggable(modal, false); }, 150);
    window.setTimeout(function() { setQuickViewGalleryDraggable(modal, false); }, 450);
    modal.scrollTop = 0;
    var scrollTarget = quickViewScrollTarget(modal);
    if (scrollTarget && scrollTarget !== modal) scrollTarget.scrollTop = 0;
    var content = modal.querySelector("#Product-Modal-Content");
    if (content) content.scrollTop = 0;
  }

  function prepareQuickViewOpen() {
    var modal = productModal();
    if (!modal) return;
    if (modal.hasAttribute("open") || document.body.classList.contains("nbn-quick-view-open") || modal.querySelector("#Product-Modal-Content")?.children.length) {
      resetQuickViewState();
    }
    modal.setAttribute("aria-busy", "true");
    setQuickViewViewportHeight();
  }

  function preferredVariantFromTrigger(trigger) {
    if (!trigger) return "";
    var card = trigger.closest("product-card[data-nbn-location-card]");
    return String(
      trigger.dataset.nbnPreferredVariantId ||
      card?.dataset?.nbnPreferredVariantId ||
      card?.getAttribute("data-nbn-preferred-variant-id") ||
      trigger.dataset.productId ||
      ""
    );
  }

  function applyPreferredVariantToTrigger(trigger) {
    var preferredVariantId = preferredVariantFromTrigger(trigger);
    if (!preferredVariantId || !/^\d+$/.test(preferredVariantId)) return "";
    trigger.dataset.productId = preferredVariantId;
    trigger.setAttribute("data-product-id", preferredVariantId);
    trigger.dataset.nbnPreferredVariantId = preferredVariantId;
    return preferredVariantId;
  }

  function selectQuickViewPreferredVariant(variantId) {
    if (!variantId) return;
    var modal = productModal();
    if (!modal || !modal.hasAttribute("open")) return;
    var input = modal.querySelector('form [name="id"]');
    if (input && String(input.value) !== String(variantId)) {
      input.value = String(variantId);
      input.dispatchEvent(new Event("input", { bubbles: true }));
      input.dispatchEvent(new Event("change", { bubbles: true }));
    }
    modal.querySelectorAll('input[type="radio"], option').forEach(function(option) {
      if (String(option.value) === String(variantId)) {
        if (option.tagName === "OPTION") option.selected = true;
        else option.checked = true;
        option.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
    document.dispatchEvent(new CustomEvent("variant:changed", { detail: { variantId: String(variantId) } }));
  }

  function rememberQuickViewPreferredVariant(trigger) {
    var preferredVariantId = applyPreferredVariantToTrigger(trigger);
    if (!preferredVariantId) return;
    window.__nbnQuickViewPreferredVariantId = preferredVariantId;
    window.setTimeout(function() { selectQuickViewPreferredVariant(preferredVariantId); }, 120);
    window.setTimeout(function() { selectQuickViewPreferredVariant(preferredVariantId); }, 450);
    window.setTimeout(function() { selectQuickViewPreferredVariant(preferredVariantId); }, 900);
  }

  function submitCartForm(form, button) {
    var variantInput = form.querySelector('[name="id"]');
    if (!variantInput || !variantInput.value || button.dataset.nbnQuickAddBusy === "1") return;

    button.dataset.nbnQuickAddBusy = "1";
    setLoading(button, true);

    var formData = new FormData(form);
    formData.set("id", variantInput.value);
    if (!formData.get("quantity")) formData.set("quantity", "1");
    formData.append("sections", sectionsToRender().map(function(section) { return section.section; }));
    formData.append("sections_url", window.location.pathname);

    fetch(cartAddUrl(), {
      method: "POST",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        "Accept": "application/javascript"
      },
      body: formData
    })
      .then(function(response) { return response.json(); })
      .then(function(response) {
        if (response && !response.status) {
          closeQuickViewDrawer(form);
          renderCartSections(response);
          document.dispatchEvent(new CustomEvent("cart:item-added", {
            detail: { product: response.hasOwnProperty("items") ? response.items[0] : response }
          }));
        } else if (response && response.description) {
          var wrapper = form.closest("product-form")?.querySelector(".product-form__error-message-wrapper");
          var message = wrapper?.querySelector(".product-form__error-message");
          if (wrapper && message) {
            message.textContent = response.description;
            wrapper.removeAttribute("hidden");
          }
        }
      })
      .catch(function(error) {
        console.error("NBN quick view add-to-cart fallback failed", error);
      })
      .finally(function() {
        setLoading(button, false);
        delete button.dataset.nbnQuickAddBusy;
      });
  }

  document.addEventListener("click", function(event) {
    var button = event.target.closest('product-form[data-section*="quick-view"] .single-add-to-cart-button');
    if (!button) return;

    var form = button.closest("form");
    if (!form) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (button.disabled || button.getAttribute("aria-disabled") === "true") return;
    submitCartForm(form, button);
  }, true);

  document.addEventListener("quick-view:open", function() {
    var modal = productModal();
    if (modal) modal.removeAttribute("aria-busy");
    selectQuickViewPreferredVariant(window.__nbnQuickViewPreferredVariantId);
    window.requestAnimationFrame(stabiliseProductModal);
  });

  window.addEventListener("resize", setQuickViewViewportHeight);
  if (window.visualViewport) {
    window.visualViewport.addEventListener("resize", setQuickViewViewportHeight);
    window.visualViewport.addEventListener("scroll", setQuickViewViewportHeight);
  }

  document.addEventListener("pointerdown", function(event) {
    var closeButton = event.target.closest("#Product-Modal .product-modal__toggle, #ModalClose-Product-Modal");
    if (!closeButton) return;
    var modal = productModal();
    if (!modal || !modal.hasAttribute("open")) return;
    event.preventDefault();
    event.stopPropagation();
    closeProductModal(modal);
  }, { capture: true, passive: false });

  document.addEventListener("click", function(event) {
    var closeButton = event.target.closest("#Product-Modal .product-modal__toggle, #ModalClose-Product-Modal");
    if (!closeButton) return;
    var modal = productModal();
    if (!modal || !modal.hasAttribute("open")) return;
    event.preventDefault();
    event.stopPropagation();
    closeProductModal(modal);
  }, true);

  document.addEventListener("touchend", function(event) {
    var closeButton = event.target.closest("#Product-Modal .product-modal__toggle, #ModalClose-Product-Modal");
    if (!closeButton) return;
    var modal = productModal();
    if (!modal || !modal.hasAttribute("open")) return;
    event.preventDefault();
    event.stopPropagation();
    closeProductModal(modal);
  }, { capture: true, passive: false });

  var quickViewTouch = null;
  var quickViewMomentumFrame = 0;

  document.addEventListener("click", function(event) {
    var quickViewButton = event.target.closest("quick-view[data-product-handle]");
    if (!quickViewButton) return;
    rememberQuickViewPreferredVariant(quickViewButton);
    prepareQuickViewOpen();
  }, true);

  document.addEventListener("keypress", function(event) {
    var quickViewButton = event.target.closest("quick-view[data-product-handle]");
    if (!quickViewButton || event.key !== "Enter") return;
    rememberQuickViewPreferredVariant(quickViewButton);
    prepareQuickViewOpen();
  }, true);

  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.target && mutation.target.id === "Product-Modal") {
        if (mutation.target.hasAttribute("open")) {
          stabiliseProductModal();
        } else {
          unlockQuickViewBody();
        }
      }
    });
  });

  function observeProductModal() {
    var modal = productModal();
    if (modal) observer.observe(modal, { attributes: true, attributeFilter: ["open"] });
  }

  observeProductModal();
  window.addEventListener("load", observeProductModal);
  document.addEventListener("DOMContentLoaded", observeProductModal);

  new MutationObserver(observeProductModal).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener("click", function(event) {
    var button = event.target.closest(".product-card--add-to-cart-button-simple");
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (button.disabled || button.dataset.nbnQuickAddBusy === "1") return;

    var variantId = button.dataset.productId;
    if (!variantId) return;

    button.dataset.nbnQuickAddBusy = "1";
    setLoading(button, true);

    var formData = new FormData();
    formData.append("id", variantId);
    formData.append("quantity", "1");
    formData.append("sections", sectionsToRender().map(function(section) { return section.section; }));
    formData.append("sections_url", window.location.pathname);

    fetch(cartAddUrl(), {
      method: "POST",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        "Accept": "application/javascript"
      },
      body: formData
    })
      .then(function(response) { return response.json(); })
      .then(function(response) {
        if (response && !response.status) {
          renderCartSections(response);
          document.dispatchEvent(new CustomEvent("cart:item-added", {
            detail: { product: response.hasOwnProperty("items") ? response.items[0] : response }
          }));
        }
      })
      .catch(function(error) {
        console.error("NBN quick add guard failed", error);
      })
      .finally(function() {
        setLoading(button, false);
        delete button.dataset.nbnQuickAddBusy;
      });
  }, true);
})();
